import React from "react";
import MetaTags from "./components/MetaTags";
import { AppBarFour } from "./components/AppBar";
import { Container, Row, Col } from "react-bootstrap";
import { PiMapPinSimpleAreaBold } from "react-icons/pi";
import { BiPhoneCall } from "react-icons/bi";
import { MdOutlineAlternateEmail } from "react-icons/md";
import Mark from "./components/Mark";
const ContactUs = () => {
  return (
    <div className="overflow-hidden">
      <MetaTags
        title="Contact Us - CM CRACKERS - Wholesale & Retail Crackers"
        type="website"
        siteName="cmcracker.in"
        url="https://cmcracker.in/contactus"
        keywords="Contact Us | CM Crackers | Skanda Agency | Sivakasi Crackers"
        description="Contact CM CRACKERS for wholesale and retail crackers in Sivakasi"
        revisitAfter="10 Days"
      />
      <AppBarFour />
      <img
        src={require("../assets/images/banner/banner_onefour.jpg")}
        className="img-fluid w-100"
        alt="product name"
      />
      <Container className="padding">
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} className="py-3">
            <h1 className="bold black text-center"> Contact Us</h1>
          </Col>
          <Col lg="4" md="12" className="py-3">
            <a href="https://maps.app.goo.gl/XSVwdszNMXfRqupQ7" target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="box" style={{ cursor: 'pointer' }}>
                <div className="box-icon">
                  <PiMapPinSimpleAreaBold size={40} color={"#000"} />
                </div>
                <div className="bold"> 6/78, Tollgate, Penpuram, Sattur Main Road, Eturvattam, Sivakasi.</div>
              </div>
            </a>
          </Col>
          <Col lg="4" className="py-3">
            <div className="box">
              <div className="box-icon">
                <BiPhoneCall size={40} color={"#000"} />
              </div>
              <div>
                <li className="bold"><a href="tel:+919566781723" style={{ textDecoration: 'none', color: 'inherit' }}>+91 95667 81723</a></li>
                <li className="bold"><a href="tel:+917010824857" style={{ textDecoration: 'none', color: 'inherit' }}>+91 70108 24857</a></li>
              </div>
            </div>
          </Col>
          <Col lg="4" className="py-3">
            <div className="box">
              <div className="box-icon">
                <MdOutlineAlternateEmail size={40} color={"#000"} />
              </div>
              <div className="pb-4">
                <div className="bold"> skandaagency1309@gmail.com</div>
              </div>
            </div>
          </Col>

          <Col lg="12" md="12" xs="12" className="py-5">
            <>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28491.264258150535!2d77.80321135!3d9.46656345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06cee43d812d0d%3A0x8ce12e9dcdaa2a2c!2sSivakasi%2C%20Tamil%20Nadu!5e1!3m2!1sen!2sin!4v1789829943800!5m2!1sen!2sin"
                width="100%"
                height="500"
                style={{ border: 0, borderRadius: "12px", boxShadow: "0 8px 25px rgba(0,0,0,0.1)" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                title="Google Maps Embed of CM CRACKERS - SKANDA AGENCY, Sivakasi"
              ></iframe>
            </>
          </Col>
        </Row>
      </Container>

      <>
        <Mark />
      </>
    </div>
  );
};

export default ContactUs;
